<template>
  <section class="ds-job-list-box">
    <div class="job-main" @click="goDetail">
      <div class="flex all-t job-top">
        <div class="ds-job-list-img mr10">
          <img v-if="showImg && (item.storePhotos || item.imgUrl)" :src="item.storePhotos || item.imgUrl" alt />
          <div v-else-if="showImg" class="no-img-placeholder" :class="rowIndex % 2 === 0 ? 'no-img-odd' : 'no-img-even'">
            {{
              (item.title || '')[0] }}</div>
          <p v-if="mapAddress && !showDistance" class="f10">距离{{ formattedDistance }}</p>
        </div>
        <div class="ds-job-list-info flex-1">
          <div class="flex title-row">
            <span class="title-text f-b flex-1">{{ item.title }}</span>
            <div class="salary-col">
              <span class="c-orange f-b salary-text">{{ salaryNumber }}<span class="salary-unit">{{ salaryUnit
              }}</span></span>
              <p class="distance-text" v-if="showDistance && distanceText">
                <img class="location-icon" src="../../assets/images/post/address.png" />
                距您 {{ distanceText }} km
              </p>
            </div>
          </div>
          <div class="flex tag-row" v-if="item.commissionVleader">
            <span class="reward-tag" v-if="item.commissionVleader" @click.stop="showCommissionTips"><img class="reward-icon" src="../../assets/images/common/salary.png" /> {{ rewardText
            }}</span>
            <span class="urgent-tag" v-if="item.commissionVleader && item.commissionVleader.expirationDate">急招</span>
          </div>
        </div>
      </div>
      <div class="job-bottom">
        <p class="welfare-row">
          <span class="job-type-tag">{{ item.jobType === 1 ? '全职' : '兼职' }}</span>
          <span class="welfare-tag-item" v-for="(welfare, index) in item.welfare" :key="index">{{ welfare }}</span>
        </p>
        <p class="meta-row" v-if="item.jobType === 2">
          <img class="meta-icon" src="../../assets/images/post/time.png" />
          <span class="shift-type">{{ item.partTimeJobShiftName }}</span>
          <span class="meta-text">{{ item.partTimeJobShiftStart }}~{{ item.partTimeJobShiftEnd }}</span>
        </p>
        <p class="meta-row store-row">
          <img class="meta-icon" src="../../assets/images/post/city.png" />
          <span class="meta-text">{{ item.storeName }}</span>
        </p>
        <p class="requirement-text">{{ experienceRequireName }} · {{ item.ageRequireLower }}-{{ item.ageRequireUpper }}岁
          · {{
            sexTypeName }}
        </p>
      </div>
    </div>
    <div class="ds-job-list-footer van-hairline--top">
      <div class="fl f12 c-gray footer-left">
        <span class="f12 c-gray lb-vm">剩余名额<span class="c-333"> {{ item.currentDemand || 0 }}</span>人 已报名<span
            class="c-333">{{ item.signNums4Vleader || 0 }}</span>人</span>
      </div>
      <div class="fr txt-r footer-actions">
        <van-button type="primary" round size="small" class="btn-gradient plr24 share-btn" v-if="!item.button"
          @click="confirm(item.id)">
          <img class="share-btn-icon" src="../../assets/images/post/share.png" />
          <span class="f14">转发</span>
        </van-button>
        <van-button type="primary" round plain size="small" v-if="item.button" class="plain-btn share-btn"
          @click="confirm(item.id)">
          <img class="share-btn-icon" src="../../assets/images/post/share.png" />
          <span class="f14" :class="{ 'c-gray': item.button }">继续转发</span>
        </van-button>
      </div>
    </div>
  </section>
</template>

<script>
import { Toast, Dialog } from 'vant';
import login from '../../mixins/login';
import recruit from '../../mixins/recruit';

export default {
  mixins: [login, recruit],
  data() {
    return {
      currentId: null,
    };
  },
  props: {
    rowIndex: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: () => {
      }
    },
    showImg: {
      type: Boolean,
      default: true
    },
    pickStatus: Number,
    mapAddress: {
      type: Object,
      default: null
    },
    showDistance: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    salaryNumber() {
      if (this.item.jobPayLower === this.item.jobPayUpper) {
        return this.item.jobPayLower;
      }
      return `${this.item.jobPayLower}~${this.item.jobPayUpper}`;
    },
    salaryUnit() {
      return `元/${this.salaryTypeName}`;
    },
    rewardText() {
      if (!this.item.commissionVleader) return '';
      const v = this.item.commissionVleader;
      if (v.commissionType === 1 && v.averageMonth) return `奖励约${v.averageMonth}元`;
      if (v.commissionType === 2 && v.oneTimeFee) return `奖励约${v.oneTimeFee}元`;
      if (v.commissionType === 3 && v.inEmployed) return `奖励约${v.inEmployed}元/月`;
      return '';
    },
    // 与后端 jobPayUnit 枚举保持一致：1:元/时 2:元/天 3:元/月
    salaryTypeName() {
      const map = { 1: '时', 2: '天', 3: '月' };
      return map[this.item.jobPayUnit] || '月';
    },
    // 性别：1-男, 2-女, 其他-不限
    sexTypeName() {
      if (this.item.genderRequire === 1) return '男';
      if (this.item.genderRequire === 2) return '女';
      return '不限性别';
    },
    // 经验要求：-1:不限 0:1年以内 1:1-3年 3:3-5年 5:5-10年 10:10年以上
    experienceRequireName() {
      const map = {
        '-1': '经验不限',
        '0': '1年以内',
        '1': '1-3年',
        '3': '3-5年',
        '5': '5-10年',
        '10': '10年以上'
      };
      const key = String(this.item.experienceRequire);
      return map[key] || '经验不限';
    },
    // 距离：后端返回单位米，统一展示为 km（保留一位小数）
    distanceText() {
      const d = this.item.distance;
      if (d === null || d === undefined || d === '' || Number(d) < 0) return '';
      return (Number(d) / 1000).toFixed(1);
    },
    // 旧版图片浮层距离（搜索页/门店详情页沿用）
    formattedDistance() {
      if (!this.item.distance) return '';
      if (this.item.distance >= 1000) {
        return (this.item.distance / 1000).toFixed(1) + 'km';
      }
      return Math.round(this.item.distance) + 'm';
    },
    // 奖励月份
    commissionMonths() {
      return [
        { key: 'month1', label: '第一个月' },
        { key: 'month2', label: '第二个月' },
        { key: 'month3', label: '第三个月' },
        { key: 'month4', label: '第四个月' },
        { key: 'month5', label: '第五个月' },
        { key: 'month6', label: '第六个月' },
        { key: 'month7', label: '第七个月' },
        { key: 'month8', label: '第八个月' },
        { key: 'month9', label: '第九个月' },
        { key: 'month10', label: '第十个月' },
        { key: 'month11', label: '第十一个月' },
        { key: 'month12', label: '第十二个月' }
      ];
    },
    // 有效出勤单位
    effectiveAttendanceUnitText() {
      const map = { 1: '时', 2: '天', 3: '月' };
      return this.item.commissionVleader ? map[this.item.commissionVleader.effectiveAttendanceUnit] || '' : '';
    }
  },
  methods: {
    goDetail() {
      if (this.mapAddress) {
        this.go(`recruit-detail?id=${this.item.id}&dis=${this.item.distance}`);
      } else {
        this.go(`recruit-detail?id=${this.item.id}`);
      }
    },
    confirm(id) {
      this.currentId = id;
      this.checkShare(this.doConfirm);
    },
    doConfirm() {
      this.$emit('confirm', this.currentId);
    },
    // 将时间戳转换为字符串格式 (yyyy年MM月dd日)
    formatTimestampToString(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    showCommissionTips() {
      if (!this.item.commissionVleader) return;

      let title = '';
      let message = '';
      if (this.item.commissionVleader.commissionType === 1) {
        title = '阶段性奖励';
        message = '';
        this.commissionMonths.forEach(month => {
          if (this.item.commissionVleader[month.key]) {
            message += `${month.label}${this.item.commissionVleader[month.key]}元\n`;
          }
        });
      } else if (this.item.commissionVleader.commissionType === 2) {
        title = '一次性奖励';
        message += `${this.item.commissionVleader.oneTimeFee}元\n`;
      } else if (this.item.commissionVleader.commissionType === 3) {
        title = '在职长返奖励';
        message += `${this.item.commissionVleader.inEmployed}元\n`;
      }

      const effectiveTime = this.item.commissionVleader.effectiveAttendance
        ? `\n\n需满足有效时间：${this.item.commissionVleader.effectiveAttendance}${this.effectiveAttendanceUnitText}`
        : '';

      Dialog.alert({
        title: title,
        message: message.trim() + effectiveTime,
        confirmButtonText: '确定'
      });
    },
  }
};
</script>
<style lang="less" scoped>
.ds-job-list-tab-no-img {
  margin-left: 8px;
}

.ds-job-list-box {
  margin: 0 12px 10px;
  padding: 0;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.job-main {
  padding: 14px 14px 0;
}

.job-top {
  display: flex;
  align-items: flex-start;
}

.job-bottom {
  padding-top: 11px;
}

.ds-job-list-img img {
  width: 48px;
  height: 48px;
  border-radius: 15px;
  object-fit: cover;
}

.no-img-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 15px;
  font-weight: bold;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-img-odd {
  background: #DCFCE8;
  color: #008236;
}

.no-img-even {
  background: #FCE7F3;
  color: #C6005C;
}

.title-row {
  align-items: flex-start;
  margin-bottom: 9px;
}

.salary-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 8px;
  flex-shrink: 0;
}

.salary-col .salary-text {
  margin-left: 0;
}

.distance-text {
  display: flex;
  align-items: center;
  margin: 4px 0 0;
  font-size: 10px;
  font-weight: 400;
  line-height: 1;
  color: #99A1AF;
  white-space: nowrap;
}

.location-icon {
  width: 12px;
  height: 12px;
  margin-right: 2px;
  flex-shrink: 0;
}

.title-text {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #1F2A37;
}

.salary-text {
  font-size: 16px;
  line-height: 1;
  color: #FB7613;
  white-space: nowrap;
  margin-left: 8px;
  font-weight: bold;
}

.salary-unit {
  font-size: 12px;
}

.tag-row {
  align-items: center;
  // margin-bottom: 15px;
  gap: 6px;
}

.reward-tag {
  display: inline-flex;
  align-items: center;
  background: rgba(251,118,19,0.1);
  font-weight: 500;
  font-size: 10px;
  color: #FB7613;
  line-height: 1;
  padding: 2px 8px;
  border-radius: 20px;
  white-space: nowrap;
}

.reward-icon {
  width: 14px;
  height: 14px;
  margin-right: 2px;
  flex-shrink: 0;
}

.urgent-tag {
  display: inline-block;
  background: rgba(231,55,55,0.1);
  box-sizing: border-box;
  color: #E73737;
  font-size: 10px;
  line-height: 15px;
  padding: 2px 8px;
  border-radius: 20px;
  font-weight: 500;
}

.welfare-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}

.job-type-tag {
  display: inline-flex;
  align-items: center;
  height: 18px;
  line-height: 18px;
  padding: 2px 8px;
  border-radius: 20px;
  font-weight: 500;
  background: rgba(251,118,19,0.1);
  color: #FB7613;
  font-size: 11px;
}

.welfare-tag-item {
  display: inline-flex;
  align-items: center;
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  border-radius: 20px;
  background: #F3F4F6;
  color: #6B7280;
  font-size: 11px;
}

.meta-row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.meta-icon {
  margin-right: 6px;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.shift-type {
  color: #FB7613;
  font-size: 12px;
  font-weight: 500;
  margin-right: 6px;
}

.meta-text {
  color: #6B7280;
  font-size: 12px;
  font-weight: 400;
}

.store-row {
  margin-bottom: 2px;
}

.requirement-text {
  font-size: 11px;
  color: #99A1AF;
  font-weight: 400;
  line-height: 1.5;
}

.ds-job-list-info {
  padding: 2px 0 0;
}

.ds-job-list-footer {
  margin-top: 10px;
  padding: 10px 14px 12px;
  min-height: 34px;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ds-job-list-footer.van-hairline--top::after {
  border-color: #E5E7EB;
}

.footer-left {
  float: none;
}

.footer-actions {
  float: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.share-btn {
  width: 70px;
  height: 30px;
  padding: 0;
  border-radius: 16px;
  font-size: 12px;
  background: #FB7613;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.share-btn /deep/ .van-button__text {
  display: flex;
  align-items: center;
  line-height: 0;
}

.share-btn-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}

.plain-btn.share-btn {
  border-color: #f5631a;
  color: #f5631a;
}
</style>